import { ReposApi } from '@appfolio/backstage-plugin-code-search-common';
import { createApiRef } from '@backstage/core-plugin-api';

export const reposApiRef = createApiRef<ReposApi>({
  id: 'plugin.repos.service',
});
